import React, { Component } from 'react';
import PropTypes from 'prop-types';

class KeyPhrases extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            expanded: false,
            enLangauge: true
        }
    }

    componentWillMount() {
        // Check if selected language is not English (in which case we don't show key phrases)
        var code = localStorage.getItem('languageCode');
        if (code && code !== 'en') {
            this.state = {
                enLangauge: false
            }
        }
    }

    toggle() {
        this.setState({
            expanded: this.state.expanded ? false : true
        })
    }

    render() {

        var that = this;
        var toggleClasses = 'fa group-toggle'
        if (this.state.expanded) {
            toggleClasses += ' fa-chevron-down';
        } else {
            toggleClasses += ' fa-chevron-right';
        }

        return(
            <div>
            {(this.props.phrases && this.props.phrases.length > 0 && this.state.enLangauge) &&
                <div>
                    <h2 className="group-title" onClick={ this.toggle }>
                        key phrases (<span className='results-count'>{ this.props.phrases.length }</span>)
                        <span className={toggleClasses}/>
                    </h2>

                    <div className={ this.state.expanded ? 'group-body indent-body expanded' : 'group-body indent-body' }>
                    {
                        this.props.phrases.map(function(phrase, idx) {
                            if (that.props.weights && that.props.weights.length == that.props.phrases.length) {
                                return <div key={idx}>{phrase}  ({that.props.weights[idx]})</div>
                            } else {
                                return <div key={idx}>{phrase}</div>
                            }
                        })                      
                    }
                    </div>
                </div>
            }
            </div>
        );
    }
};

KeyPhrases.propTypes = {
    phrases: PropTypes.array,
    weights: PropTypes.array
};

export default KeyPhrases;

